<script>
  import flyCalculator from './../../_fly-calculator'

  export default {

    data() {
      return {
        options: {},

        currentPersonId: 1,
        currentPersonBasedata: {},
        currentPersonBaseline: {},

        personBaselineTmpl: {
          position: null,

          consumption_monthly_expense: 400,
          consumption_hotel_visits: 'zwei',
          consumption_cf_investment: 0,
          consumption_compensate_emissions: 0,

          consumption_consumer_habits: 'durchschnittlich',
          consumption_consumer_criteria: 'funktion',
          consumption_used_goods: 'manchmal',

          food: 'gemischt',

          mobility_travel_mode: 'general',
          mobility_carsharing_general_performance: 0,
          mobility_bicycle_general_performance: 0,
          mobility_train_general_performance: 0,

          mobility_air_mode: 'general',

          mobility_air_general_europe_hours: 0,
          mobility_air_general_europe_flight_compensated: 0,
          mobility_air_general_europe_flight_class: 'economy',

          mobility_air_general_world_hours: 0,
          mobility_air_general_world_flight_compensated: 0,
          mobility_air_general_world_flight_class: 'economy',

          mobility_air_values: [],

          // mobility_travel_values_count: 0,
          mobility_travel_values: []
        },

        ridesTmpl: {
          name: '',
          vehicle: '',
          road_performance: 0,
          days: 20,
          person: 1,
        },

      }
    },

    props: ['persons', 'baselinePersons', 'hideCallback', 'month'],

    components: {flyCalculator},

    methods: {
      personSelectChanged() {
        this.$nextTick(function () {
          this.currentPersonBasedata = this._.find(this.persons, ['position', this.currentPersonId]);
          this.currentPersonBaseline = this._.find(this.baselinePersons, ['position', this.currentPersonId]);
        })
      },
      addTravelValue() {
        this.currentPersonBaseline.mobility_travel_values.push({...this.ridesTmpl});
      },
      removeTravelValue(ride) {
        let indx = this.currentPersonBaseline.mobility_travel_values.indexOf(ride);
        this.currentPersonBaseline.mobility_travel_values.splice(indx, 1);
      },
      addFly(flyObj) {

        let airValue = {

          // database fields
          airport_start_icao: flyObj.airport_start_obj.icao,
          airport_stopover_icao: flyObj.airport_stopover_obj ? flyObj.airport_stopover_obj.icao : null,
          airport_dest_icao: flyObj.airport_dest_obj.icao,
          airport_flight_mode: 2,
          airport_flight_amount: 1,
          airport_flight_class: 'economy',
          airport_flight_compensated: 0,

        };

        // dynamic fields
        airValue.airport_start_obj = this.co2Service.getFlyData(airValue.airport_start_icao);
        airValue.airport_stopover_obj = airValue.airport_stopover_icao ? this.co2Service.getFlyData(airValue.airport_stopover_icao) : null;
        airValue.airport_dest_obj = this.co2Service.getFlyData(airValue.airport_dest_icao);

        // Distanz berechnen
        if (airValue.airport_stopover_obj) {
          // Zwischenstop vorhanden
          let distanceFirst = this.co2Service.calcDistanz(airValue.airport_start_obj.lat, airValue.airport_start_obj.lon, airValue.airport_stopover_obj.lat, airValue.airport_stopover_obj.lon);
          let distanceSecnd = this.co2Service.calcDistanz(airValue.airport_stopover_obj.lat, airValue.airport_stopover_obj.lon, airValue.airport_dest_obj.lat, airValue.airport_dest_obj.lon);
          airValue.distance = distanceFirst + distanceSecnd;
        } else {
          airValue.distance = this.co2Service.calcDistanz(airValue.airport_start_obj.lat, airValue.airport_start_obj.lon, airValue.airport_dest_obj.lat, airValue.airport_dest_obj.lon);
        }

        if(!this.currentPersonBaseline.mobility_air_values) {
          this.currentPersonBaseline.mobility_air_values = [];
        }

        this.currentPersonBaseline.mobility_air_values.push(airValue);
      },
      removeFly(airValue) {
        let indx = this.currentPersonBaseline.mobility_air_values.indexOf(airValue);
        this.currentPersonBaseline.mobility_air_values.splice(indx, 1);
      },
    },

    mounted() {
      console.log('Basedata personsx', this.persons.length);
      console.log('Baseline personsx', this.baselinePersons.length);

      if (this.persons || this.persons.length > 0) {

        this.options = this.co2Service.getOptions();

        this.persons.map((person) => {

          let personBaseline = this._.find(this.baselinePersons, ['position', person.position]);

          if (!personBaseline) { // Person noch nicht in baseline-daten
            let newPersonBl = {...this.personBaselineTmpl};
            newPersonBl.position = person.position;
            newPersonBl.mobility_travel_values = [];
            newPersonBl.mobility_air_values = [];
            this.baselinePersons.push(newPersonBl);

            personBaseline = this._.find(this.baselinePersons, ['position', person.position]);
          }

          if(personBaseline && !personBaseline.mobility_travel_values) {
            this.$set(personBaseline, 'mobility_travel_values', []);
          }

          if(personBaseline && !personBaseline.mobility_air_values) {
            this.$set(personBaseline, 'mobility_air_values', []);
          }
        });

        this.currentPersonBasedata = this.persons[0];
        this.currentPersonBaseline = this._.find(this.baselinePersons, ['position', this.currentPersonBasedata.position]);
        this.currentPersonId = this.currentPersonBasedata.position;
      }
    },

    // beforeDestroy: function () {
    //   console.log('destroy persons');
    //   this.hideCallback(this.persons)
    // }
  }

</script>
<style lang="scss">
  .baseline-persons {
    label {
      cursor: pointer !important;
    }
  }

</style>
<template>
  <div class="baseline-persons">

    <div v-if="!persons || persons.length < 1" class="text-warning text-center mt-3 mb-5">
      <font-awesome-icon class="fa-fw mr-1" icon="exclamation-triangle"></font-awesome-icon>
      <span>Bisher wurden keine Personen im Grunddatensatz angegeben. <router-link
        :to="{ name: 'user.co2rechner.grunddaten' }">Bitte erst anlegen!</router-link></span>
    </div>

    <div v-else class="person-select-header text-center">

      <b-form-group id="group-person_select" class="d-inline">
        <b-form-radio-group
          id="input-person_select"
          @input="personSelectChanged"
          v-model="currentPersonId"
          :options="persons"
          text-field="displayName"
          value-field="position"
          buttons
          class="cursor-pointer"
          size="sm"
          button-variant="outline-secondary"
          name="person_select"
        ></b-form-radio-group>
      </b-form-group>
    </div>

    <div v-if="currentPersonBasedata">

      <div class="text-center">
        <h4 class="text-primary">Personenangaben für: <span class="text-secondary">{{ currentPersonBasedata.displayName }}</span>
        </h4>
        <hr>
      </div>

      <b-row>
        <b-col md="6">

          <h5 class="mb-3 mt-3 text-secondary">
            <font-awesome-icon class="fa-fw mr-1" icon="euro-sign"/>
            Konsumverhalten im {{month}}
          </h5>

          <!-- Moantliche Ausgaben -->
          <b-form-group
            class="mt-2"
            id="input-living_hc_space"
            label="Durchschnittliche monatliche Konsumausgaben:"
            label-for="input-living_hc_space">
            <b-input-group size="sm">
              <b-form-input
                id="input-living_hc_space"
                v-model="currentPersonBaseline.consumption_monthly_expense"
                type="range"
                min="150" max="900" step="50"
                required
                size="sm"
                rounded
              ></b-form-input>
              <template slot="append">
                <b-input-group-text>{{currentPersonBaseline.consumption_monthly_expense}} €</b-input-group-text>
              </template>
            </b-input-group>
          </b-form-group>

          <!-- Person Kaufverhalten -->
          <b-form-group id="group-consumption_consumer_habits" label="Kaufverhalten:" label-for="input-consumption_consumer_habits">
            <b-form-radio-group
              id="input-consumption_consumer_habits"
              v-model="currentPersonBaseline.consumption_consumer_habits"
              :options="options.consumption_consumer_habits"
              name="input-consumption_consumer_habits"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <!-- Person Kaufkriterien -->
          <b-form-group id="group-consumption_consumer_criteria" label="Kaufkriterien:" label-for="input-consumption_consumer_criteria">
            <b-form-radio-group
              id="input-consumption_consumer_criteria"
              v-model="currentPersonBaseline.consumption_consumer_criteria"
              :options="options.consumption_consumer_criteria"
              name="input-consumption_consumer_criteria"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <!-- Person Gebrauchte Gegenstände -->
          <b-form-group id="group-consumption_used_goods" label="Gebrauchte Gegenstände:" label-for="input-consumption_used_goods">
            <b-form-radio-group
              id="input-consumption_used_goods"
              v-model="currentPersonBaseline.consumption_used_goods"
              :options="options.consumption_used_goods"
              name="input-consumption_used_goods"
              stacked
            ></b-form-radio-group>
          </b-form-group>

        </b-col>
        <b-col md="6">

          <h5 class="mb-3 mt-3">&nbsp;</h5>

          <!-- Geldanlage -->
          <b-form-group class="mt-2"
                        id="group-consumption_cf_investment"
                        label="Klimafreundliche Geldanlage:"
                        label-for="input-consumption_cf_investment">
            <b-input-group size="sm">
              <b-form-input
                id="input-consumption_cf_investment"
                v-model="currentPersonBaseline.consumption_cf_investment"
                type="number"
                size="sm"
                rounded
              ></b-form-input>
              <template slot="append">
                <b-input-group-text>€</b-input-group-text>
              </template>
            </b-input-group>
          </b-form-group>

          <!-- Geldanlage -->
          <b-form-group class="mt-2"
                        id="group-consumption_compensate_emissions"
                        label-for="input-consumption_compensate_emissions">
            <template slot="label">
              Kompensationen von CO<sub>2</sub>:
            </template>
            <b-input-group size="sm">
              <b-form-input
                id="input-consumption_compensate_emissions"
                v-model="currentPersonBaseline.consumption_compensate_emissions"
                type="number"
                size="sm"
                rounded
              ></b-form-input>
              <template slot="append">
                <b-input-group-text>Tonnen CO<sub>2</sub></b-input-group-text>
              </template>
            </b-input-group>
          </b-form-group>

          <!-- Hotelübernachtungen -->
          <b-form-group id="group-consumption_hotel_visits"
                        label="Hotelübernachtungen:"
                        label-for="input-consumption_hotel_visits">
            <b-form-radio-group
              id="input-consumption_hotel_visits"
              v-model="currentPersonBaseline.consumption_hotel_visits"
              :options="options.consumption_hotel_visits_month"
              name="input-consumption_hotel_visits"
              stacked
            ></b-form-radio-group>
          </b-form-group>

          <h5 class="mb-3 mt-3 text-secondary">
            <font-awesome-icon class="fa-fw mr-1" icon="utensils"/>
            Ernährung
          </h5>

          <!-- Person Ernährungsform -->
          <b-form-group id="group-food" label="Ernährungsform:" label-for="input-food">
            <b-form-radio-group
              id="input-food"
              v-model="currentPersonBaseline.food"
              :options="options.food"
              name="input-food"
              stacked
            ></b-form-radio-group>
          </b-form-group>

        </b-col>
      </b-row>

      <hr>

      <b-row>
        <b-col md="6">

          <h5 class="mb-3 mt-3 text-secondary">
            <font-awesome-icon class="fa-fw mr-1" icon="train"/>
            Fahrten und Reisen
          </h5>

          <b-alert variant="info" show>
            Bitte beachten Sie dass Fahrten mit einem eigenen Fahrzeug im Bereich "Fahrzeugangaben" erfasst werden!<br>
            Nur private Fahrten/Arbeitsanreise angeben. Keine Geschäftsreisen.

            <transition name="fade">
               <span v-if="currentPersonBaseline.mobility_travel_mode === 'general'">
                <br><br>Bei CarSharing oder Fahrgemeinschaften bitte die Distanzen durch die Anzahl der Mitfahrer teilen.
               </span>
            </transition>

          </b-alert>

          <span>Erfassung der Fahrten:</span>
          <b-form-group id="group-mobility_travel_mode" class="d-inline ml-2">
            <b-form-radio-group
              id="input-mobility_travel_mode"
              v-model="currentPersonBaseline.mobility_travel_mode"
              :options="options.mobility_travel_mode"
              value-field="value"
              buttons
              class="cursor-pointer"
              size="sm"
              button-variant="outline-secondary"
              name="mobility_travel_mode"
            ></b-form-radio-group>
          </b-form-group>

          <div v-if="currentPersonBaseline.mobility_travel_mode === 'general'">

            <h6 class="mb-3 mt-3 text-info">
              <font-awesome-icon class="fa-fw mr-1" icon="car"/>
              Carsharing/Fahrgemeinschaften im {{month}}
            </h6>

            <b-form-group class="mt-2"
                          id="group-mobility_carsharing_general_performance"
                          label="Fahrdistanz:"
                          label-for="input-mobility_carsharing_general_performance">
              <b-input-group size="sm">
                <b-form-input
                  id="input-mobility_carsharing_general_performance"
                  v-model="currentPersonBaseline.mobility_carsharing_general_performance"
                  type="number"
                  size="sm"
                  rounded
                ></b-form-input>
                <template slot="append">
                  <b-input-group-text>km</b-input-group-text>
                </template>
              </b-input-group>
            </b-form-group>

            <h6 class="mb-3 mt-3 text-info">
              <font-awesome-icon class="fa-fw mr-1" icon="bicycle"/>
              Fahrrad im {{month}}
            </h6>

            <b-form-group class="mt-2"
                          id="group-mobility_bicycle_general_performance"
                          label="Fahrdistanz:"
                          label-for="input-mobility_bicycle_general_performance">
              <b-input-group size="sm">
                <b-form-input
                  id="input-mobility_bicycle_general_performance"
                  v-model="currentPersonBaseline.mobility_bicycle_general_performance"
                  type="number"
                  size="sm"
                  rounded
                ></b-form-input>
                <template slot="append">
                  <b-input-group-text>km</b-input-group-text>
                </template>
              </b-input-group>
            </b-form-group>

            <h6 class="mb-3 mt-3 text-info">
              <font-awesome-icon class="fa-fw mr-1" icon="bus"/>
              Öffentliche Verkehrsmittel im {{month}}
            </h6>

            <b-form-group class="mt-2"
                          id="group-mobility_train_general_performance"
                          label="Fahrdistanz:"
                          label-for="input-mobility_train_general_performance">
              <b-input-group size="sm">
                <b-form-input
                  id="input-mobility_train_general_performance"
                  v-model="currentPersonBaseline.mobility_train_general_performance"
                  type="number"
                  size="sm"
                  rounded
                ></b-form-input>
                <template slot="append">
                  <b-input-group-text>km</b-input-group-text>
                </template>
              </b-input-group>
            </b-form-group>

          </div>

          <div v-if="currentPersonBaseline.mobility_travel_mode === 'detail'">

            <b-card class="mb-2" body-class="p-1" border-variant="secondary" align="left"
                    v-for="(ride, $index) in currentPersonBaseline.mobility_travel_values" :key="$index">
              <b-card-text>

                <!-- Name -->
                <b-form-group class="mt-2"
                              :id="'group-mobility_travel_values_name_' + $index"
                              :label-for="'input-mobility_travel_values_name_' + $index">
                  <template slot="label">
                    Bezeichnung:
                    <small>(z.B. "Fahrt zur Arbeit")</small>
                  </template>
                  <b-form-input
                    :id="'input-mobility_travel_values_name_' + $index"
                    v-model="ride.name"
                    type="text"
                    size="sm"
                    rounded
                  ></b-form-input>
                </b-form-group>

                <!-- Verkehrsart -->
                <b-form-group :id="'group-mobility_travel_values_vehicle_' + $index"
                              label="Verkehrsmittel:"
                              :label-for="'input-mobility_travel_values_vehicle_' + $index">
                  <b-form-select
                    :id="'input-mobility_travel_values_vehicle_' + $index"
                    v-model="ride.vehicle"
                    :options="options.mobility_travel_values_vehicle"
                    size="sm"
                    required
                  ></b-form-select>
                </b-form-group>

                <b-row>
                  <b-col md="6">

                    <!-- Distanz -->
                    <b-form-group :id="'group-mobility_travel_values_road_performance_' + $index"
                                  label="Distanz (hin und zurück):"
                                  :label-for="'input-mobility_travel_values_road_performance_' + $index">
                      <b-input-group size="sm">
                        <b-form-input
                          :id="'input-mobility_travel_values_road_performance_' + $index"
                          v-model="ride.road_performance"
                          type="number"
                          size="sm"
                          rounded
                        ></b-form-input>
                        <template slot="append">
                          <b-input-group-text>km</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>

                  </b-col>
                  <b-col md="6">

                    <!-- Tage -->
                    <b-form-group :id="'group-mobility_travel_values_days_' + $index"
                                  label="Anzahl der Fahrten:"
                                  :label-for="'input-mobility_travel_values_days_' + $index">
                      <b-input-group size="sm">
                        <b-form-input
                          :id="'input-mobility_travel_values_days_' + $index"
                          v-model="ride.days"
                          type="number"
                          min="1"
                          max="31"
                          step="1"
                          size="sm"
                          rounded
                        ></b-form-input>
                        <template slot="append">
                          <b-input-group-text>Tage</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>


                  </b-col>
                </b-row>

                <!-- Anzahl Personen im Fahrzeug -->
                <transition name="fade">
                  <b-form-group :id="'group-mobility_travel_values_person_' + $index"
                                v-if="ride.vehicle === 'carsharing'"
                                label="Anzahl der Personen im Fahrzeug"
                                :label-for="'input-mobility_travel_values_person_' + $index">
                    <b-input-group size="sm">
                      <b-form-input
                        :id="'input-mobility_travel_values_person_' + $index"
                        v-model="ride.person"
                        type="number"
                        min="1"
                        max="100"
                        step="0.5"
                        size="sm"
                        rounded
                      ></b-form-input>
                      <template slot="append">
                        <b-input-group-text>Person(en)</b-input-group-text>
                      </template>
                    </b-input-group>
                  </b-form-group>
                </transition>

                <b-button class="float-right" size="sm" rounded variant="danger" @click="removeTravelValue(ride)">
                  <font-awesome-icon class="fa-fw mr-1" icon="trash"></font-awesome-icon>
                  <span>Fahrt entfernen</span>
                </b-button>

              </b-card-text>
            </b-card>

            <b-button class="mr-2" size="sm" rounded variant="secondary" @click="addTravelValue()">
              <font-awesome-icon class="fa-fw mr-1" icon="plus"></font-awesome-icon>
              <span>Fahrtblock hinzufügen</span>
            </b-button>

          </div>


        </b-col>
        <b-col md="6">

          <h5 class="mb-3 mt-3 text-secondary">
            <font-awesome-icon class="fa-fw mr-1" icon="plane"/>
            Flugreisen
          </h5>

          <b-alert variant="info" show>
            Nur private Flüge angeben. Keine Geschäftsreisen.
          </b-alert>

          <span>Erfassung der Flugreisen:</span>
          <b-form-group id="group-mobility_air_mode" class="d-inline ml-2">
            <b-form-radio-group
              id="input-mobility_travel_mode"
              v-model="currentPersonBaseline.mobility_air_mode"
              :options="options.mobility_travel_mode"
              value-field="value"
              buttons
              class="cursor-pointer"
              size="sm"
              button-variant="outline-secondary"
              name="mobility_travel_mode"
            ></b-form-radio-group>
          </b-form-group>


          <div v-if="currentPersonBaseline.mobility_air_mode === 'general'">

            <h6 class="mb-2 mt-3 text-info">
              <font-awesome-icon class="fa-fw mr-1" icon="globe-europe"/>
              Flugreisen Europa im {{month}}
            </h6>

            <b-row>
              <b-col md="6">

                <b-form-group id="group-mobility_air_general_europe_hours"
                              label="Flugzeit:"
                              label-for="input-mobility_air_general_europe_hours">
                  <b-input-group size="sm">
                    <b-form-input
                      id="input-mobility_air_general_europe_hours"
                      v-model="currentPersonBaseline.mobility_air_general_europe_hours"
                      type="number"
                      step="1"
                      size="sm"
                      rounded
                    ></b-form-input>
                    <template slot="append">
                      <b-input-group-text>Stunden</b-input-group-text>
                    </template>
                  </b-input-group>
                </b-form-group>

              </b-col>
              <b-col md="6">

                <b-form-group id="input-mobility_air_general_europe_flight_compensated" label="Bereits kompensiert?"
                              label-for="input-mobility_air_general_europe_flight_compensated">
                  <b-form-radio-group
                    id="input-mobility_air_general_europe_flight_compensated"
                    v-model="currentPersonBaseline.mobility_air_general_europe_flight_compensated"
                    :options="options.no_yes"
                    buttons
                    class="cursor-pointer"
                    size="sm"
                    button-variant="outline-secondary"
                    name="mobility_air_general_europe_flight_compensated"
                  ></b-form-radio-group>
                </b-form-group>

              </b-col>
            </b-row>

            <b-form-group id="input-mobility_air_general_europe_flight_class" label="Flugklasse:"
                          label-for="input-mobility_air_general_europe_flight_class">
              <b-form-radio-group
                id="input-mobility_air_general_europe_flight_class"
                v-model="currentPersonBaseline.mobility_air_general_europe_flight_class"
                :options="options.mobility_air_general_europe_flight_class"
                buttons
                class="cursor-pointer"
                size="sm"
                button-variant="outline-secondary"
                name="mobility_air_general_europe_flight_class"
              ></b-form-radio-group>
            </b-form-group>


            <h6 class="mb-2 mt-4 text-info">
              <font-awesome-icon class="fa-fw mr-1" icon="globe-americas"/>
              Flugreisen Transkontinental im {{month}}
            </h6>

            <b-row>
              <b-col md="6">

                <b-form-group id="group-mobility_air_general_world_hours"
                              label="Flugzeit:"
                              label-for="input-mobility_air_general_world_hours">
                  <b-input-group size="sm">
                    <b-form-input
                      id="input-mobility_air_general_world_hours"
                      v-model="currentPersonBaseline.mobility_air_general_world_hours"
                      type="number"
                      step="1"
                      size="sm"
                      rounded
                    ></b-form-input>
                    <template slot="append">
                      <b-input-group-text>Stunden</b-input-group-text>
                    </template>
                  </b-input-group>
                </b-form-group>

              </b-col>
              <b-col md="6">

                <b-form-group id="input-mobility_air_general_world_flight_compensated" label="Bereits kompensiert?"
                              label-for="input-mobility_air_general_world_flight_compensated">
                  <b-form-radio-group
                    id="input-mobility_air_general_world_flight_compensated"
                    v-model="currentPersonBaseline.mobility_air_general_world_flight_compensated"
                    :options="options.no_yes"
                    buttons
                    class="cursor-pointer"
                    size="sm"
                    button-variant="outline-secondary"
                    name="mobility_air_general_world_flight_compensated"
                  ></b-form-radio-group>
                </b-form-group>

              </b-col>
            </b-row>

            <b-form-group id="input-mobility_air_general_world_flight_class" label="Flugklasse:"
                          label-for="input-mobility_air_general_world_flight_class">
              <b-form-radio-group
                id="input-mobility_air_general_world_flight_class"
                v-model="currentPersonBaseline.mobility_air_general_world_flight_class"
                :options="options.mobility_air_general_world_flight_class"
                buttons
                class="cursor-pointer"
                size="sm"
                button-variant="outline-secondary"
                name="mobility_air_general_world_flight_class"
              ></b-form-radio-group>
            </b-form-group>

          </div>

          <div v-if="currentPersonBaseline.mobility_air_mode === 'detail'">

            <b-card class="mb-2" body-class="p-1" border-variant="secondary" align="left"
                    v-for="(flight, $index) in currentPersonBaseline.mobility_air_values" :key="$index">
              <b-card-text>

                <div class="text-primary">Flug {{$index + 1}} von <u>{{ flight.airport_start_obj.port }}</u> nach <u>{{
                  flight.airport_dest_obj.port }}</u> <span v-if="flight.airport_stopover_obj"> über {{ flight.airport_stopover_obj.port }}</span>
                </div>
                <div>Distanz: {{flight.distance}} km</div>
                <div>Anzahl der Flüge: <strong>{{flight.airport_flight_amount}}</strong></div>
                <div>Flugklasse: <strong>{{options.mobility_air_general_world_flight_class[flight.airport_flight_mode].text}}</strong>
                </div>
                <div v-if="flight.airport_flight_compensated === 1"><strong>Flug wurde kompensiert.</strong></div>

                <b-button class="float-right pt-0 pb-0" size="sm" rounded variant="danger" @click="removeFly(flight)">
                  <font-awesome-icon class="fa-fw mr-1" icon="trash"></font-awesome-icon>
                  <span>Flug entfernen</span>
                </b-button>

              </b-card-text>
            </b-card>

            <b-button class="mr-2" size="sm" rounded variant="secondary" @click="$refs.modalFlyCalculator.show()">
              <font-awesome-icon class="fa-fw mr-1" icon="plus"></font-awesome-icon>
              <span>Flug hinzufügen</span>
            </b-button>


          </div>

          <fly-calculator ref="modalFlyCalculator" :hide-callback="addFly"></fly-calculator>

        </b-col>
      </b-row>

      <div class="text-right">

        <span>Weiter zu Person: </span>
        <b-form-group id="group-person_select2" class="d-inline ml-2 mb-0">
          <b-form-radio-group
            id="input-person_select2"
            @input="personSelectChanged"
            v-model="currentPersonId"
            :options="persons"
            text-field="displayName"
            value-field="position"
            buttons
            class="cursor-pointer"
            size="sm"
            button-variant="outline-secondary"
            name="person_select2"
          ></b-form-radio-group>
        </b-form-group>

      </div>



    </div>
  </div>
</template>
